module.exports = __webpack_public_path__ + "static/media/iconExercicesF.f36278f0.svg";